import { render, staticRenderFns } from "./_closeTaskModal.vue?vue&type=template&id=31e21bd7"
import script from "./_closeTaskModal.vue?vue&type=script&lang=js"
export * from "./_closeTaskModal.vue?vue&type=script&lang=js"
import style0 from "./_closeTaskModal.vue?vue&type=style&index=0&id=31e21bd7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports